import { useState } from "react";
import StyledTable, { ColumnHeader } from "../../../../components/table/styled-table";
import ExerciseTableRow from "./exercise-table-row";
import { configs } from "../../../../app/app-configs";
import { Exercise } from "../../../../service/model/workout.model";

const headers: ColumnHeader[] = [
    { name: "Name" },
    { name: "Muscle Group" },
    // { name: "Equipment" },
    { name: "Description" },
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly exercises: Exercise[]
}

const ExerciseTable: React.FC<TableProps> = ({ exercises }) => {

    const [page, setPage] = useState(1);

    const pageCount = Math.ceil(exercises.length / configs.PAGE_SIZE);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <StyledTable headers={headers}
            currentPage={page}
            totalPages={pageCount}
            onPageChange={handlePageChange}>

            {(configs.PAGE_SIZE > 0
                ? exercises.slice((page - 1) * configs.PAGE_SIZE, (page - 1) * configs.PAGE_SIZE + configs.PAGE_SIZE)
                : exercises
            )?.map(exercise =>
                <ExerciseTableRow exercise={exercise} key={exercise.id} />
            )}
        </StyledTable>
    );
}

export default ExerciseTable;